import React from "react";
import {
  BenefitQuadrantBase,
  Headline,
  Subheadline,
  Footer,
  Benefits,
  Benefit,
  BenefitCopy,
  Image,
  Title,
  Description,
} from "./benefit-quadrant.styled";
import { BenefitQuadrantSliceFragment } from "../../types/graphql";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type IBenefitQuadrantProps = Slice<
  SharedSliceType,
  BenefitQuadrantSliceFragment["primary"],
  BenefitQuadrantSliceFragment["items"][number]
> & { type: SharedSliceType.benefit_quadrant };

const BenefitQuadrant = ({
  slice,
  context,
}: SliceComponentProps<IBenefitQuadrantProps, IPageContext>) => {
  return (
    (slice && (
      <BenefitQuadrantBase>
        {slice.primary?.headline && (
          <Headline>{slice.primary?.headline}</Headline>
        )}
        {slice.primary?.subheadline && (
          <Subheadline>
            <PrismicRichText
              field={slice.primary?.subheadline.richText}
              components={htmlSerializer}
            />
          </Subheadline>
        )}
        {slice.items && (
          <Benefits>
            {slice.items.slice(0, 4).map((benefit, index) => {
              return (
                (benefit && (
                  <Benefit key={index}>
                    {benefit.image?.url && (
                      <Image
                        width={benefit.image.dimensions?.width}
                        height={benefit.image.dimensions?.height}
                        src={benefit.image.url}
                        alt={benefit.image.alt || "Xometry Image"}
                      />
                    )}
                    <BenefitCopy>
                      {benefit.title && <Title>{benefit.title}</Title>}
                      {benefit.description && (
                        <Description>
                          <PrismicRichText
                            field={benefit.description.richText}
                            components={htmlSerializer}
                          />
                        </Description>
                      )}
                    </BenefitCopy>
                  </Benefit>
                )) || <></>
              );
            })}
          </Benefits>
        )}
        {slice.primary?.footer && (
          <Footer>
            <PrismicRichText
              field={slice.primary.footer.richText}
              components={htmlSerializer}
            />
          </Footer>
        )}
      </BenefitQuadrantBase>
    )) || <></>
  );
};

export default BenefitQuadrant;
